.segmented-buttons-container {
  font-family: var(--font-family);
  display: flex;
  justify-content: center;
  width: calc(100% - 32px);
  height: 40px;
  margin: 16px;
  border: 1px solid var(--color-outline);
  border-radius: var(--border-radius, 20px);
  line-height: 20px;
  .segment {
    cursor: pointer;
    user-select: none;
    font-size: 14px;
    font-weight: 500;
    -webkit-tap-highlight-color: transparent;
    color: var(--color-on-surface);
    background-color: transparent;
    border-radius: 0px;
    min-width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    &:first-child {
      border-top-left-radius: var(--border-radius, 20px);
      border-bottom-left-radius: var(--border-radius, 20px);
    }
    &:not(:last-child) {
      border-right: 1px solid var(--color-outline);
    }
    &:last-child {
      border-top-right-radius: var(--border-radius, 20px);
      border-bottom-right-radius: var(--border-radius, 20px);
    }
  }
  .selected-segment {
    color: var(--color-on-primary-container);
    background-color: var(--color-primary-container);
  }
}
